import React from 'react';
import classnames from 'classnames';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';

import Link from '@/components/Link';
import Tab from './Tab';
import Typography from '@/components/Typography';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

interface Props {
  resourceId: string;
  className?: string;
}

const TabbedContainer: React.FC<Props & RouteComponentProps> = ({ resourceId, className, children, location }) => {
  const renderTabItem = (child: Tab, index: number) => {
    const url = child.props.to.get(resourceId);
    const isTabActive = location.pathname === url;

    return (
      <TabsTrigger key={index} value={url} asChild>
        <Link to={url}>
          <Typography is="span" size="base">
            {child.props.title}
          </Typography>
        </Link>
      </TabsTrigger>
    );
  };

  return (
    <div className={classnames('h-full w-full flex flex-col', className)}>
      <Tabs value={location.pathname} className="w-full">
        <div className="w-full mb-5">
          <TabsList className="flex flex-row items-center justify-start">
            {React.Children.map(children, renderTabItem)}
          </TabsList>
        </div>

        <Switch>
          {React.Children.map(children, (child: Tab, index) => {
            return (
              <Route
                key={index}
                exact={child.props.exact ?? true}
                path={child.props.to.main}
                component={() => child as any}
              />
            );
          })}
        </Switch>
      </Tabs>
    </div>
  );
};

export default withRouter(TabbedContainer);
